import { render, staticRenderFns } from "./SliceProductsRowTile.vue?vue&type=template&id=747acbc5&lang=pug&"
import script from "./SliceProductsRowTile.vue?vue&type=script&lang=js&"
export * from "./SliceProductsRowTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports